import { TempLogo } from "@/assets/temp-logo";
import { useNavigate } from "@tanstack/react-router";

import Footer from "@/components/Common/Footer";

export default function VerifyEmail({
  forgotPassword,
}: {
  forgotPassword?: boolean;
}) {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-between px-4 pb-8">
      <div className="flex w-full max-w-[420px] flex-grow flex-col justify-center gap-8">
        {/* Logo and App Name */}
        <div className="text-center">
          <div className="flex justify-center">
            <TempLogo width={68} height={44} />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">metawhale</h1>
        </div>

        <div className="w-[420px] space-y-10">
          <p
            className="text-muted flex cursor-pointer flex-row items-center gap-1 text-sm leading-normal font-bold tracking-normal"
            onClick={() => navigate({ to: "/login" })}
          >
            <i className="ri-arrow-left-long-line"></i>
            Back
          </p>
          <div className="space-y-3 text-center">
            {forgotPassword ? (
              <>
                <h1 className="text-[28px] leading-[36px] font-bold -tracking-wide text-neutral-950">
                  Check your inbox
                </h1>
                <p className="text-sm leading-none font-semibold text-neutral-800">
                  We've sent you an email to verify your email address.{" "}
                  <span className="leading-normal whitespace-nowrap">
                    Click the link in your inbox to continue.
                  </span>
                </p>
              </>
            ) : (
              <>
                <h1 className="text-[28px] leading-[36px] font-bold -tracking-wide text-neutral-950">
                  Password has been reset successfully
                </h1>
                <p className="text-sm leading-none font-semibold text-neutral-800">
                  You can now login with your new password.{" "}
                </p>
              </>
            )}
          </div>
          {/* <div className="space-y-3 text-center">
            <p className="text-sm leading-none font-semibold text-neutral-500">
              Did not receive an email?
            </p>
            <Button className="text-md h-[48px] w-full leading-normal">
              Resend verification email
            </Button>
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}
